import { render, staticRenderFns } from "./EsqueciSenhaExterno.vue?vue&type=template&id=2e80c5ea&"
import script from "./EsqueciSenhaExterno.vue?vue&type=script&lang=js&"
export * from "./EsqueciSenhaExterno.vue?vue&type=script&lang=js&"
import style0 from "./EsqueciSenhaExterno.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports